import { styled } from "@mui/material/styles";

const ActiveJobsMain = styled("div")(({ theme }) => ({
  "& .TableWrapper ": {
    marginTop: "0px",

    "& .status_driver.assigned": {
      background: "rgba(0, 193, 8, 0.15)",
      color: "#01B108",
    },
  },
}));

export { ActiveJobsMain };
